export default __webpack_public_path__ + "static/media/average-speed.be1804ee.svg";